import { Page } from './Page';
import {
  AlignItems,
  Body1,
  Box,
  Col,
  Color,
  Display,
  FlexDirection,
  Grid,
  GridVariant,
  Heading1,
  JustifyContent,
  Link,
  Logo,
  LogoVariant,
  TextAlign,
} from '@gousto-internal/citrus-react';

export default function ErrorPage() {
  return (
    <Page customerLoggedIn={false}>
      <Grid variant={GridVariant.Layout} paddingV={[4, null, 12]} rowGap={[4, null, 6]}>
        <Col
          gridColumn={['1 / span 12', '2 / span 10', '2 / span 10', '4 / span 6']}
          display={Display.Flex}
          alignItems={AlignItems.Center}
          flexDirection={FlexDirection.Column}
          gap={4}
        >
          <Box
            bg={Color.Primary_500}
            width="130px"
            height="130px"
            display={Display.Flex}
            alignItems={AlignItems.Center}
            justifyContent={JustifyContent.Center}
          >
            <Logo logoVariant={LogoVariant.Default} size={8} />
          </Box>
          <Heading1 textAlign={TextAlign.Center}>We&apos;re in a bit of a pickle</Heading1>
          <Body1 textAlign={TextAlign.Center}>
            We can&apos;t seem to find the page you were looking for. Please try again or contact
            our <Link href="https://help.gousto.ie">customer care</Link> team to get things cooking
            again.
          </Body1>
        </Col>
      </Grid>
    </Page>
  );
}
